import { Route, Routes } from "react-router-dom";
import Index, {
  Search,
  ItemnumberView,
} from "./pages";
import Redirect from "../../components/Redirect";
import { PageableTableProvider } from "../../context/PageableTableContext";
import GuardRoute from "components/navigation/GuardRoute";
import { ItemNumberSearchesProvider } from "context/ItemNumberSearchesContext";

// const requesterPermission = ["api.requester_tcc_request"];
// const approverPermissions = [
//   "api.regional_approver_tcc_request",
//   "api.global_market_approver_tcc_request",
//   "api.global_approver_tcc_request",
// ];

const ItemnumberRoutes = () => (
  <Routes>
    <Route path="/" element={<Index />}>
      <Route
        // element={
        //   <GuardRoute
        //     neededPermissions={[...requesterPermission, ...approverPermissions]}
        //   />
        // }
      >
        <Route
          path="search"
          element={
            <PageableTableProvider>
              <ItemNumberSearchesProvider>
                <Search />
              </ItemNumberSearchesProvider>
            </PageableTableProvider>
          }
        />
      </Route>            
    

      <Route
        // element={
        //   <GuardRoute
        //     neededPermissions={[...requesterPermission, ...approverPermissions]}
        //   />
        // }
      >
        <Route path="view" element={<ItemnumberView />} />
      </Route>
    </Route>
    <Route path="*" element={<Redirect to="search" />} />
  </Routes>
);

export default ItemnumberRoutes;
